export enum CalendarSetStatus {
  Active = "Active",
  Inactive = "Inactive",
  Draft = "Draft",
}
